import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import { Loader , Link} from '@jutro/components';
import { MetadataContent } from '@jutro/uiconfig';
import { withIntl, TranslatorContext } from '@jutro/locale';
import { Currency as CurrencyField } from 'gw-components-platform-react';
//import { policyCommissionMessages } from 'gw-capability-gateway-commission-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { JobUtil } from 'gw-portals-util-js';
import { GatewayPolicyService} from 'gw-capability-ri-policy';
import billingTermsStyles from './BillingTerms.module.scss';
import metadata from './BillingTerms.metadata.json5';
import messages from './BillingTerms.messages';

class BillingTerms extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            billingData: PropTypes.shape({})
        }).isRequired,
        intl: PropTypes.func.isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
    };

    state = {
        billingTermsData: [],
        isbillingTermsAvailable: false,
        isLoading: true
    };

    componentDidMount = () => {
        this.getPolicyTermsInfo();
    };
    
    getPolicyTermsInfo = async () => {
        const { authHeader, fromAccountLanding } = this.props;

        const billingTermsResponse = _.get(
            fromAccountLanding,
            'billingData.policyPeriodBillingSummaries[0].relatedAccountBillingSummaries_Ext'
        );     
        if (!_.isEmpty(billingTermsResponse) && billingTermsResponse.length > 0) {
            const billingTermsDataTable = this.getBillingTermsDataTable(billingTermsResponse);

            this.setState({
                billingTermsData: billingTermsDataTable, 
                isLoading: false, 
                isbillingTermsAvailable: billingTermsDataTable.length > 0 // FB 16137
            });
        } else {
            this.setState({ isbillingTermsAvailable: false, isLoading: false});
        }
    };

    getBillingTermsDataTable = (billingTermsResponse, sorted) => {
        
        // FB 22768 ----- 
        // Expand the billing accounts with multiple policies to seperate account entity with single policy
        const expandedBillingAccounts = billingTermsResponse.flatMap(billingTermsResponse => {
            if (billingTermsResponse.ownedPolicies.length > 1) {
                // Clone the account for each policy, replacing ownedPolicies with a single object
                return billingTermsResponse.ownedPolicies.map(policy => ({
                    ...billingTermsResponse,
                    ownedPolicies: policy // Replace array with single policy object
                }));
            } else {
                // Replace array with the single policy object
                return {
                    ...billingTermsResponse,
                    ownedPolicies: billingTermsResponse.ownedPolicies[0]
                };
            }
        });
        // ----- FB 22768

        let invoiceArrayResult = [];
        invoiceArrayResult = expandedBillingAccounts.map((billingaccount) => {

            const objData = {
                policyNbr: billingaccount.ownedPolicies.policyNumber, 
                policyEffective: billingaccount.ownedPolicies.policyEffectiveDate,
                billingAccount: billingaccount.billingAccountNumber_Ext,
                status: billingaccount.status_Ext,
                minAmountDue: billingaccount.ownedPolicies.policyAmtCurrentDue,
                isDelinquent: billingaccount.isDelinquent || billingaccount.status_Ext === 'Delinquent' || moment().isAfter(billingaccount.dueDate_Ext),
                dueDate: billingaccount.dueDate_Ext
            };
            return objData;
        });

        const sortedData = _.orderBy(invoiceArrayResult, (o) => {
            return o.policyEffective;
          }, ['desc']);   

        return sortedData;
    };

    getPolicyLink = (item, index, property) => {
        const toolTipMessage = {
        //     policyNumber: translator(claimsMessages.policyNumberClaimDetail),
        //     claimNumber: translator(claimsMessages.claimNumber)
        };

        const policyNbr = item.policyNbr.split(",");
        if (property.id === 'policyNbr') {
            const redirectRoute = `/ri-billing/${policyNbr[0]}/summary` // FB 16531
            const redirectPath = {
                pathname: redirectRoute,
                state: {
                    policyNumber: item[property.id],
                    redirectPath: '/ri-billing',
                }
            };
            return (
                <Link
                    to={redirectPath}
                    className={billingTermsStyles.gwClaimsLinkContent}
                    title={toolTipMessage[property.id]}
                >
                    {item[property.id]}
                </Link>
            );    
        } else {
            return item[property.id]

        }
    };

    getCell = (item, index, property) => {               
        const classNameisDelinquent = item.isDelinquent ? billingTermsStyles.riDelinquent : '';

        return (
            <span className={classNameisDelinquent}>
                {item[property.id]}
            </span>
        );
    };

    getFormattedDateField = (item, index, property) => {
        const classNameisDelinquent = property.id === 'dueDate' && item.isDelinquent ? billingTermsStyles.riDelinquent : '';
        return (
            <span className={classNameisDelinquent}>
                {this.getFormattedDate(item[property.id])}
            </span>
        );
    };

    getFormattedCurrency = (item, index, property) => {       
        const amount = _.get(item[property.id],'amount');

        const classNameisDelinquent = item.isDelinquent && amount !== 0 ? billingTermsStyles.riDelinquent2 : '';
        return (
            <CurrencyField
                id={`currency_${index}`}
                value={item[property.id]}
                readOnly
                hideLabel
                showOptional={false}    
                className={classNameisDelinquent}                
            />
        );
    };

    getFormattedDate = (date) => {
        const { intl } = this.props;
        const d = date === undefined ? null : 
            intl.formatDate(new Date(date), { year: 'numeric', month: 'short', day: 'numeric' });
        return d;
    };

    getPolicyStatusIcon = (billingData) => {
        if (billingData.isDelinquent) {
            return 'mi-warning';
        }
        return 'mi-check';
    };

    getPolicyStatusClassname = (billingData) => {
        if (billingData.isDelinquent) {
            return 'policy-billing-icon policy-billing-delinquent';
        }
        return 'policy-billing-icon policy-billing-good-standing';
    };

    render() {
        const {
            billingTermsData,            
            isbillingTermsAvailable,
            isLoading
        } = this.state;
        const translator = this.context;

        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }        

        const overrides = {
            billingTermsTable: {
                data: billingTermsData
            },
            billingTermsContainer: {
                visible: isbillingTermsAvailable
            },
            billingEmptyContainer: {
                visible: !isbillingTermsAvailable
            },
            warningMessage: {
                value: translator(messages.noBillingTermsDataLabel)
            }
        };
        const resolvers = {
            resolveClassNameMap: billingTermsStyles,
            resolveCallbackMap: {
                getCell: this.getCell,
                getPolicyLink: this.getPolicyLink,
                getFormattedCurrency: this.getFormattedCurrency,
                getFormattedDate: this.getFormattedDateField,
                handlePolicyPeriodChange: this.handlePolicyPeriodChange,
                handleViewAccountBilling: this.handleViewAccountBilling
            }
        };

        //const policyPage = renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
        //return <div className={billingTermsStyles.billingterms}>{policyPage}</div>;
        return (
            <div className={billingTermsStyles.billingterms}>
                <MetadataContent
                    uiProps={metadata.pageContent}
                    overrideProps={overrides}
                    {...resolvers}
                />
            </div>
        );
    }
}

export const BillingTermsComponent = BillingTerms;
export default withIntl(withAuthenticationContext(BillingTerms));
